var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.4769 12.4669L6.69825 15.0351L9.10629 23.6002C9.26037 24.1488 9.86688 24.3516 10.2695 23.9875L13.7373 20.8608C14.1008 20.5332 14.6186 20.5169 14.9985 20.8218L21.2533 25.8444C21.684 26.1906 22.2941 25.9296 22.4021 25.354L26.9841 0.977435C27.102 0.348737 26.5435 -0.175743 26.0022 0.0557888L0.46961 10.9496C-0.160481 11.2184 -0.154991 12.205 0.4769 12.4669ZM8.71821 13.668L20.877 5.38549C21.0956 5.23707 21.3204 5.56387 21.1327 5.75638L11.0982 16.0728C10.7455 16.4359 10.5179 16.9218 10.4535 17.4493L10.1117 20.251C10.0664 20.6251 9.5913 20.6622 9.49797 20.3002L8.18334 15.1912C8.03277 14.6085 8.25219 13.9861 8.71821 13.668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.6ddce965d9b9eb16d9ee2a2aa10dc27e.svg";
export { ForwardRef as ReactComponent };